import { Injectable } from '@angular/core';
import { GenericalService } from '../../shared/services/generical.service';
import {API_ENDPOINT} from '../../app.api';


@Injectable({
  providedIn: 'root'
})
export class SubprojectCategoryService {

  constructor(private gServ : GenericalService) { }

  getAll() {
  	let url = `${API_ENDPOINT}/subproject/categories`;
  	return this.gServ.get(url);
  }

  getByType(_type) {
  	let url = `${API_ENDPOINT}/subproject/categories?_type=${_type}`;
  	return this.gServ.get(url);
  }

}
